import StartMenu from './StartMenu';
export default StartMenu;
